import React from "react"
import { injectIntl } from "react-intl"
import BaseNoResult from "../../common/no-result/BaseNoResult"
import IntlProps from "../../state/helpers/IntlProps"
import { messages } from "./messages"


const NoPayoutsProcessed = (props: IntlProps) => {

    return <BaseNoResult 
        title={props.intl.formatMessage(messages["NoPayoutsProcessedTitle"])}
        description={props.intl.formatMessage(messages["NoPayoutsProcessedDescription"])}
        displayImage={true}
        image={<img src="/images/Donation.svg" width="80px" alt="Payment cards" />}
    />
}

export default injectIntl(NoPayoutsProcessed)


// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/NoPayoutsProcessed.tsx